import {ComponentDefinition} from '@contentful/experiences-sdk-react';

export const DoubleTheDonationContentfulComponentDefinition: ComponentDefinition =
  {
    id: 'doubleTheDonation',
    name: 'Double the Donation',
    category: '08: Advanced',
    thumbnailUrl:
      'https://contentful-images.code.org/90t6bu6vlf76/74ExwNwZ0rUACiixPFxPKE/3d911e35a139d451127228c2f78ce12f/component_double_the_donation_icon.png',
    tooltip: {
      description:
        'Embeds the Double the Donation employee match search form. This component is case-specific and intended for use on a specific page only.',
      imageUrl:
        'https://contentful-images.code.org/90t6bu6vlf76/1yEmxilfATc6AqePRADl2h/23ffdc94ca3f7d1c86e9d7f51a9e6286/component_double_the_donation_tooltip.png',
    },
    variables: {},
  };
